import React from 'react'
import MemberOverview from './Pages/overview'
import MemberDetail from './Pages/Detail'
import MemberNew from './Pages/new'

export const MemberPagesConfig = (value: any) => {
    return [
        {
            path: '/Member/overview/:page',
            elements: <MemberOverview value={value} />,
            roles: ['superadmin', 'admin', 'consultant']
        },
        {
            path: '/Member/Detail/:id',
            elements: <MemberDetail value={value} />,
            roles: ['superadmin', 'admin', 'consultant']
        },
        {
            path: '/Member/Delete/:page/:deleteID',
            elements: <MemberOverview value={value} />,
            roles: ['superadmin', 'admin', 'consultant']
        },
        {
            path: '/Member/new/:page',
            elements: <MemberNew value={value} />,
            roles: ['superadmin', 'admin', 'consultant']
        }
    ]
}

export const MemberMenuConfig = (value: any) => {
    return [
        {
            name: 'Userverwaltung',
            route: '/Member/overview/1',
            icon: 'manage_accounts',
            roles: ['superadmin', 'admin', 'consultant']
        }
    ]
}
